import React, { useContext, useState } from 'react';
import { Button, CircularProgress, TextField } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import { toast } from 'react-toastify';
import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';

const AddCreditsPopinModal = ({ modalDetails }) => {
  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [credits, setCredits] = useState('10');

  const popin = modalDetails?.popin;
  const company = modalDetails?.company;

  const closeHandle = () => modalCtx.closeModal();

  const handleSubmit = async () => {
    if (!popin?.id) return;
    const additionalClaims = parseInt(credits, 10);
    if (!additionalClaims || Number.isNaN(additionalClaims) || additionalClaims <= 0) {
      toast.error('Please enter a valid positive number.');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/popin/${popin.id}/add-credits`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + authCtx.token
        },
        body: JSON.stringify({ additionalClaims })
      });
      const data = await response.json();
      if (data.status === 'success') {
        toast.success(`Added ${additionalClaims} credit${additionalClaims > 1 ? 's' : ''}.`);
        modalCtx.closeModal();
        modalCtx.setPageUpdate({ page: 'Popins', popinId: popin.id });
      } else {
        toast.error(data.error || 'Failed to add credits.');
      }
    } catch (error) {
      console.error('Error adding credits:', error);
      toast.error('Failed to add credits.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-devotional-container" style={{ width: '500px' }}>
      <div className="devotional-header">
        <h1>Add Pop-in credits</h1>
        <CloseRounded className="close" onClick={closeHandle} />
      </div>
      <div className="body-container create-container">
        <p><strong>Company:</strong> {company?.companyName || '—'}</p>
        <p><strong>Scans left:</strong> {popin?.scansLeft ?? '—'}</p>
        <TextField
          fullWidth
          type="number"
          label="Additional credits"
          value={credits}
          onChange={(e) => setCredits(e.target.value)}
          inputProps={{ min: 1 }}
          sx={{ mt: 1 }}
        />
      </div>
      <div className="modal-footer">
        <Button className="cancel-btn" onClick={closeHandle} disabled={loading}>Cancel</Button>
        <Button onClick={handleSubmit} disabled={loading}>
          {loading ? <CircularProgress size={16} style={{ color: '#fff' }} /> : 'Add credits'}
        </Button>
      </div>
    </div>
  );
};

export default AddCreditsPopinModal;
